import { createSlice } from "@reduxjs/toolkit";

const initialState = () => {
  const savedState = JSON.parse(localStorage.getItem("language"));
  return savedState || { language: ["English", "Tamil"] };
};

const languageState = createSlice({
  name: "LanguageState",
  initialState: initialState(),
  reducers: {
    addLanguage(state, action) {
      if (action.payload) {
        state.language.push(action.payload);
        localStorage.setItem("language", JSON.stringify(state));
      }
    },
  },
});

export const { addLanguage } = languageState.actions;
export const languageReducer = languageState.reducer;
